/**
 * Global regex patterns for data sanitization
 */
export const GLOBAL_REGEX = {
  /**
   * Regex pattern to remove diacritics from text
   * Converts accented characters to their base form
   * Example: "café" -> "cafe", "naïve" -> "naive"
   */
  DIACRITICS_SANITIZATION: /[\u0300-\u036f]/g,
  
  /**
   * Normalization form for diacritics removal
   * Uses NFD (Normalization Form Decomposed) to separate base characters from diacritics
   */
  NORMALIZATION_FORM: 'NFD'
} as const;
